<template>
    <div>
      <Swiper class="swiper" :options="swiperOption">
        <swiper-slide
          v-for="(related_channels) in relatedChannelsList" :key="related_channels.id"
        >
          <figure>
            <div class="graphic"><img v-bind:src="related_channels.imgCover"></div>
          </figure>
          <figcaption class="related_courses_content">
              <h3 class="related_courses_text related_courses_title">{{related_channels.title}}</h3>
              <b class="related_courses_text related_courses_author">{{related_channels.author.title}}</b>
          </figcaption>
          <a
          :href="'/channel/'+related_channels.id" class="fullLink"
          target="_blank"
          ></a>
        </swiper-slide>
      </Swiper>
      <div class="swiper-pagination" slot="pagination"></div>
    </div>
</template>
<script>
export default {
  name: 'RelatedChannelsBanner',
  props: {
    relatedChannelsList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      swiperOption: {
        loop: true,
        slidesPerView: 2,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicMainBullets: 4
        },
        breakpoints: {
          568: {
            slidesPerView: 3
          },
          992: {
            slidesPerView: 4
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-slide {
  padding: 10px;
  position: relative;
  z-index: 2;
}
.swiper-pagination {
  width: 100%;
  position: static;
  >>> .swiper-pagination-bullet {
    margin: 0 4px;
  }
   >>> .swiper-pagination-bullet-active {
    background-color: #176e8d;
  }
}
@media screen and (max-width: 767px){
  .swiper-pagination {
    display: none;
  }
}
figure {
  position: relative;
  z-index: -1;
  margin: 0;
  .graphic {
    border-radius: 10px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    overflow: hidden;
    position: relative;
    height: 0;
    padding-top: 69%;
    -webkit-mask-image: -webkit-radial-gradient(white, black);
    img {
      position: absolute;
      margin: auto;
      top: -9999px;
      right: -9999px;
      bottom: -9999px;
      left: -9999px;
      height: 100%;
      max-width: initial;
      transition: opacity 1s, transform 1s;
      backface-visibility: hidden;
      display: block;
    }
  }
}
.related_courses_content {
  position: relative;
  top: 0;
  width: 100%;
  margin: 0 auto;
  padding: 15px 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 10px #bfbfbf4d;
  text-align: left;
  min-height: 105px;
  transition: all .15s linear;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  .related_courses_text {
    font-size: 1.6rem;
    font-weight: normal;
    padding-top: 0;
    margin-bottom: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .related_courses_author {
    color: rgba(0,0,0,.5);
    position: absolute;
    bottom: 10px;
    left: 20px;
    max-height: 26px;
    padding-right: 10px;
    -webkit-line-clamp: 1;
  }
  .related_courses_title {
    font-weight: 600;
    line-height: 1.4;
    -webkit-line-clamp: 2;
    max-height: 45px;
    margin-bottom: 15px;
  }
}
.fullLink {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  display: block;
  text-indent: -9999px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Course/components/RelatedChannelsBanner.vue